import axios from "axios";
import { API } from "../../../../../../config/api";

const token = localStorage.getItem("token");

let fetchParams = {
    headers: {
        "Authorization": `${token}`,
        "Content-Type": "application/json"
    }
};

// SDC = API Local 
// Satu Sehat = API Satu Sehat Platform  

export const GetPatientSDC = async (idPatient) => {
    try {
        const response = await API.get(`/transaction-service/patients/${idPatient}`, fetchParams);
        return response.data.data;
    } catch (error) {
        console.error("GetPatientSDC error:", error);
        throw error;
    }
};

export const GetDoctorSDC = async (idDoctor) => {
    try {
        const response = await API.get(`/user-service/privileges/users/${idDoctor}`, fetchParams)
        return response.data.data;
    } catch (error) {
        console.error("GetPatientSDC error:", error);
        throw error;
    }
};

export const GetDebrisIndexSDC = async (idPatient, idAppointment) => {
    try {
        const response = await API.get(`/emr-service/dental-debris-patient/${idPatient}/${idAppointment}`, fetchParams)
        return response.data.data;
    } catch (error) {
        console.error("GetPatientSDC error:", error);
        throw error;
    }
};

export const GetKalkulusIndexSDC = async (idPatient, idAppointment) => {
    try {
        const response = await API.get(`/emr-service/dental-calculus-patient/${idPatient}/${idAppointment}`, fetchParams)
        return response.data.data;
    } catch (error) {
        console.error("GetKalkulusIndexSDC error:", error);
        throw error;
    }
};

export const GetLocationSatuSehat = async (idRoom) => {
    try {
        const response = await axios.get('https://api-ts.signatureanugerah.co.id/api/satu-sehat/location', {
            params: {
                'id_room': idRoom
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${token}`,
            }
        });
        return response;
    } catch (error) {
        console.error("GetLocationSatuSehat error:", error);
        throw error;
    }
};

export const GetPhysicalCheckPatientSDC = async (idPatient) => {
    try {
        const response = await API.get(`/emr-service/phy-checks/patient-id/${idPatient}`, fetchParams);
        return response.data.data;
    } catch (error) {
        console.error("GetPhysicalCheckPatientSDC error:", error);
        throw error;
    }
};

export const GetAppointmentSSPSDC = async (idPatient) => {
    try {
        const response = await API.get(`/user-service/appointment-ssp/patient/${idPatient}`, fetchParams);
        console.log(response)
        return response.data.data;
    } catch (error) {
        console.error("GetAppointmentSSPSDC error:", error);
        throw error;
    }
};

export const GetPatientByNIKSatuSehat = async (nikPatient) => {
    try {
        const response = await API.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/by-nik`, {
            params: { id_nik: nikPatient },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${token}`,
            },
        });
        // return response.data.data;
        return response;
    } catch (error) {
        console.error("GetPatientByNIKSatuSehat error:", error);
        throw error;
    }
};

export const GetPatientIndexEncounter = async (id_patient) => {
    try {
        const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
            params: {
                'id_patient': id_patient
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${token}`,
            }
        });
        return response;
    } catch (error) {
        console.error("GetPatientByNIKSatuSehat error:", error);
        throw error;
    }
};

export const GetPatientIndexEncounterById = async (id_encounter) => {
    try {
        const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter-id`, {
            params: {
                'idEncounter': id_encounter
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${token}`,
            }
        });
        return response;
    } catch (error) {
        console.error("GetPatientIndexEncounterById error:", error);
        throw error;
    }
};

export const GetPatientConditionByEncounterId = async (id_encounter) => {
    try {
        const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/condition-id`, {
            params: {
                'idEncounter': id_encounter
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${token}`,
            }
        });
        return response;
    } catch (error) {
        console.error("GetPatientConditionByEncounterId error:", error);
        throw error;
    }
};

export const GetPatientObservationByEncounterId = async (id_encounter) => {
    try {
        const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/observation-id`, {
            params: {
                'idEncounter': id_encounter
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${token}`,
            }
        });
        return response;
    } catch (error) {
        console.error("GetPatientConditionByEncounterId error:", error);
        throw error;
    }
};

export const GetPatientProcedureByEncounterId = async (id_encounter) => {
    try {
        const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/procedure-id`, {
            params: {
                'idEncounter': id_encounter
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `${token}`,
            }
        });
        return response;
    } catch (error) {
        console.error("GetPatientProcedureByEncounterId error:", error);
        throw error;
    }
};

export const PostPatientSSP = async (
    nic_number,
    first_name,
    last_name,
    phone_number,
    gender,
    date_birth,
    residence_address,
    province,
    regency,
    district,
    sub_district
) => {
    try {
        const response = await axios.post(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/patient`, {
            "nic_number": nic_number,
            "first_name": first_name,
            "last_name": last_name,
            "phone_number": phone_number,
            "gender": gender,
            "date_birth": date_birth,
            "residence_address": residence_address,
            "province": province,
            "regency": regency,
            "district": district,
            "sub_district": sub_district
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("GetPatientProcedureByEncounterId error:", error);
        throw error;
    }
};

export const PostEncounterSSP = async (
    patient_id, 
    id_appointment, 
    date_appointment, 
    time_appointment, 
    patient_firstname, 
    patient_lastname, 
    room_id, 
    room_name,
    ihs_number, 
    doctor_name
) => {
    try {
        const response = await axios.post(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/encounter`, {
            "patient_id": patient_id,
            "id_appointment": id_appointment,
            "date_appointment": date_appointment,
            "time_appointment": time_appointment,
            "patient_firstname": patient_firstname,
            "patient_lastname": patient_lastname,
            "room_id": room_id,
            "room_name": room_name,
            "ihs_number": ihs_number,
            "doctor_name": doctor_name,
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("GetPatientProcedureByEncounterId error:", error);
        throw error;
    }
};


export const PostAppointmentSSP = async (id_appointment, id_appointment_ssp, id_patient, id_patient_ssp) => {
    try {
        const response = await API.post("/user-service/appointment-ssp/store", {
            id_appointment: id_appointment,
            id_appointment_ssp: id_appointment_ssp,
            id_patient: id_patient,
            id_patient_ssp: id_patient_ssp,
            status_sistole_ssp: 0,
            status_distole_ssp: 0,
            status_diagnosis_ssp: 0,
            status_procedure_ssp: 0,
            status_observation_ssp: 0,
            status_condition_ssp: 0,
            status_odontogram_ssp: 0,
            blood_type: 0,
            rhesus: 0,
            pregnancy_status: 0,
            debris_indices: 0,
            score_debris_indices: 0,
            calculus_indices: 0,
            score_calculus_indices: 0,
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PostAppointmentSSP error:", error);
        throw error;
    }
};


export const PostBloodTypeSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, blood_type, created_at, doctor_name, ihs_number) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/blood-type", {
            patient_id: patient_id,
            encounter_id: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            blood_type: blood_type,
            created_at: created_at,
            doctor_name: doctor_name,
            ihs_number: ihs_number
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PostBloodTypeSSP error:", error);
        throw error;
    }
};

export const PostRhesusSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, rhesus, created_at, doctor_name, ihs_number) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/rhesus", {
            patient_id: patient_id,
            encounter_id: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            rhesus: rhesus,
            created_at: created_at,
            doctor_name: doctor_name,
            ihs_number: ihs_number
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PostRhesusSSP error:", error);
        throw error;
    }
};

export const PostPregnancyStatusSSP = async (patient_id, encounter_id, pregnancy_status, created_at, doctor_name, ihs_number) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/pregnancy-status", {
            patient_id: patient_id,
            encounter_id: encounter_id,
            pregnancy_status: pregnancy_status,
            created_at: created_at,
            doctor_name: doctor_name,
            ihs_number: ihs_number,
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PregnancyStatusSSP error:", error);
        throw error;
    }
};

export const PostDebrisIndexSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, debris_index, body_site_debris_index, created_at, doctor_name, ihs_number) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/debris-indices", {
            patient_id: patient_id,
            encounter_id: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            debris_index: debris_index,
            body_site_debris_index: body_site_debris_index,
            created_at: created_at,
            doctor_name: doctor_name,
            ihs_number: ihs_number
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("DebrisIndexSSP error:", error);
        throw error;
    }
};

export const PostKalkulusIndexSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, calculus_index, body_site_calculus_index, created_at, doctor_name, ihs_number) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/calculus-indices", {
            patient_id: patient_id,
            encounter_id: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            calculus_index: calculus_index,
            body_site_calculus_index: body_site_calculus_index,
            created_at: created_at,
            doctor_name: doctor_name,
            ihs_number: ihs_number
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PostKalkulusIndexSSP error:", error);
        throw error;
    }
};

export const PostScoreKalkulusIndexSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, score, created_at, doctor_name, ihs_number) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/score-kalkulus", {
            patient_id: patient_id,
            encounter_id: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            score: score,
            created_at: created_at,
            doctor_name: doctor_name,
            ihs_number: ihs_number
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PostKalkulusIndexSSP error:", error);
        throw error;
    }
};

export const PostScoreDebrisIndexSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, score, created_at, doctor_name, ihs_number) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/score-debris", {
            patient_id: patient_id,
            encounter_id: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            score: score,
            created_at: created_at,
            doctor_name: doctor_name,
            ihs_number: ihs_number,
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PostKalkulusIndexSSP error:", error);
        throw error;
    }
};


export const PostSistoleSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, doctor_firstname, doctor_lastname, blood_pressure, created_at, ihs_number, doctor_name) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/sistole", {
            patient_id: patient_id,
            id_encounter: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            doctor_firstname: doctor_firstname,
            doctor_lastname: doctor_lastname,
            blood_pressure: blood_pressure,
            created_at: created_at,
            ihs_number: ihs_number,
            doctor_name: doctor_name,
        }, fetchParams);

        return response;
    } catch (error) {
        console.error("PostKalkulusIndexSSP error:", error);
        throw error;
    }
};

export const PostDistoleSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, doctor_firstname, doctor_lastname, blood_pressure, created_at, ihs_number, doctor_name) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/distole", {
            patient_id: patient_id,
            id_appointment: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            doctor_firstname: doctor_firstname,
            doctor_lastname: doctor_lastname,
            blood_pressure: blood_pressure,
            created_at: created_at,
            ihs_number: ihs_number,
            doctor_name: doctor_name
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PostKalkulusIndexSSP error:", error);
        throw error;
    }
};

export const PostSuhuSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, doctor_firstname, doctor_lastname, body_temperature, created_at, ihs_number, doctor_name) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/observation", {
            patient_id: patient_id,
            id_appointment: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            doctor_firstname: doctor_firstname,
            doctor_lastname: doctor_lastname,
            body_temperature: body_temperature,
            created_at: created_at,
            ihs_number: ihs_number,
            doctor_name: doctor_name,
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PostSuhuSSP error:", error);
        throw error;
    }
};

export const PostTreatmentSSP = async (patient_id, encounter_id, patient_firstname, patient_lastname, code, created_at, ihs_number, doctor_name) => {
    try {
        const response = await API.post("https://api-ts.signatureanugerah.co.id/api/satu-sehat/procedure", {
            patient_id: patient_id,
            id_appointment: encounter_id,
            patient_firstname: patient_firstname,
            patient_lastname: patient_lastname,
            code: code,
            created_at: created_at,
            ihs_number: ihs_number,
            doctor_name: doctor_name,
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PostTreatmentSSP error:", error);
        throw error;
    }
};

export const PutBloodTypeSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/user-service/appointment-ssp/${appointment_id}`, {
            blood_type: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutBloodTypeSSP error:", error);
        throw error;
    }
};

export const PutRhesusSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            rhesus: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutRhesusSSP error:", error);
        throw error;
    }
};

export const PutPregnancyStatusSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            pregnancy_status: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutPregnancyStatusSSP error:", error);
        throw error;
    }
};


export const PutDebrisIndexSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            debris_indices: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutDebrisIndexSSP error:", error);
        throw error;
    }
};

export const PutKalkulusIndexSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            calculus_indices: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutKalkulusIndexSSP error:", error);
        throw error;
    }
};

export const PutSkorKalkulusIndexSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            score_calculus_indices: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutSkorKalkulusIndexSSP error:", error);
        throw error;
    }
};

export const PutSkorDebrisIndexSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            score_debris_indices: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutSkorDebrisIndexSSP error:", error);
        throw error;
    }
};

export const PutSistoleSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            status_sistole_ssp: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutSistoleSSP error:", error);
        throw error;
    }
};

export const PutDistoleSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            status_distole_ssp: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutDistoleSSP error:", error);
        throw error;
    }
};

export const PutSuhuSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            status_observation_ssp: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutSuhuSSP error:", error);
        throw error;
    }
};

export const PutTreatmentSSP = async (appointment_id, patient_id, id_appointment_ssp) => {
    try {
        const response = await API.put(`https://api-gw.signatureanugerah.co.id/user-service/appointment-ssp/${appointment_id}`, {
            status_procedure_ssp: 1,
            patient_id: patient_id,
            id_appointment_ssp: id_appointment_ssp
        }, fetchParams);
        return response;
    } catch (error) {
        console.error("PutSuhuSSP error:", error);
        throw error;
    }
};